import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { HdsTable } from '@hashicorp/design-system-components/components';
import { Typography } from 'core/components';
import { boxPadding } from 'core/modifiers';
import {
  CONTENT_TABS_LABELS,
  PRODUCT_CONSUL,
} from 'networks-common/utils/content-tabs';

import {
  TABLE_HEADERS,
  OutboundRules,
  AgentlessRules,
} from './consts/security-rules';

export default class PeeringsAzureConsulOutboundRules extends Component {
  /**
   *
   * `PeeringsAzureConsulOutboundRulesComponent` renders the Azure Consul Outbound Rules Component
   *
   *
   * ```
   * <Page::HvnPeerings::Detail::ContentTabs::Azure::Tables::Consul::OutboundRules
   *  @model={{@model}}
   * />
   * ```
   *
   * @class PeeringsAzureConsulOutboundRulesComponent
   *
   */

  tabs = CONTENT_TABS_LABELS;
  products = {
    consul: PRODUCT_CONSUL,
  };

  get outboundRules() {
    let consulRules = OutboundRules(this.args.model, this.azureSecurityGroupId);
    let agentlessRules = AgentlessRules(
      this.args.model,
      this.azureSecurityGroupId
    );
    return {
      tableHeaders: TABLE_HEADERS,
      tableData: consulRules.concat(agentlessRules),
    };
  }
  <template>
    <div
      data-test-peering-consul-outbound-rules-azure
      class="hvnsPeeringsDetail__instructions--outboundRules"
      {{boxPadding "0 0 0 0"}}
    >
      <Typography @variant="h3">
        {{t
          "components.page.hvn-peerings.detail.instructions.default.updating-groups.web-console.outbound-rules"
        }}
      </Typography>
      <HdsTable
        @valign="middle"
        @caption={{t
          "components.page.hvn-peerings.detail.instructions.default.updating-groups.web-console.table.caption"
        }}
      >
        <:head as |H|>
          <H.Tr>
            {{#each this.outboundRules.tableHeaders as |header|}}
              <H.Th>
                {{t header}}
              </H.Th>
            {{/each}}
          </H.Tr>
        </:head>
        <:body as |B|>
          {{#each this.outboundRules.tableData as |data|}}
            <B.Tr>
              <B.Td>
                {{data.priority}}
              </B.Td>
              <B.Td>
                {{data.name}}
              </B.Td>
              <B.Td>
                {{data.port}}
              </B.Td>
              <B.Td>
                {{data.protocol}}
              </B.Td>
              <B.Td>
                {{data.source}}
              </B.Td>
              <B.Td>
                {{#if data.destination}}
                  {{data.destination}}
                {{else}}
                  {{t
                    "components.page.hvn-peerings.detail.tables.rules.labels.security-group-id"
                  }}
                {{/if}}
              </B.Td>
              <B.Td>
                {{data.action}}
              </B.Td>
            </B.Tr>
          {{/each}}
        </:body>
      </HdsTable>
    </div>
  </template>
}
